export default __webpack_public_path__ + "static/media/006-half moon.54592f95.svg";